module.exports = __webpack_public_path__ + "static/media/event-custom.6d60f896.jpg";